import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpLoadingService {

  loading$ = new BehaviorSubject(false);

  constructor() {}

  httpShowLoading() {
    this.loading$.next(true);
  }

  httpHidenLoading() {
    this.loading$.next(false);
  }
}
